"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassportScoreVerifiableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PassportScoreVerifiableFactory = /** @class */ (function (_super) {
    __extends(PassportScoreVerifiableFactory, _super);
    function PassportScoreVerifiableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PassportScoreVerifiableFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PassportScoreVerifiableFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PassportScoreVerifiableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PassportScoreVerifiableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PassportScoreVerifiableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PassportScoreVerifiableFactory;
}(contracts_1.ContractFactory));
exports.PassportScoreVerifiableFactory = PassportScoreVerifiableFactory;
var _abi = [
    {
        inputs: [],
        name: "passportScoresContract",
        outputs: [
            {
                internalType: "contract ISapphirePassportScores",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x6080604052348015600f57600080fd5b5060918061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063c51da9a914602d575b600080fd5b600054603f906001600160a01b031681565b6040516001600160a01b03909116815260200160405180910390f3fea2646970667358221220d094d898228a543416264088ee9a8f84637b9639cca0659bcb54e9372620c38164736f6c63430008040033";
